import { jsxs, jsx } from 'react/jsx-runtime';

const SvgActionPhoto = (props) => jsxs("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", height: props.size, width: props.size }, props, { children: [jsx("path", { fill: "#2D2E2E", d: "M3 3v11h6.52l2.52 3H19v2H5v-3H3v5h18V3H3Zm16 12h-6.03l-2.52-3H5V5h14v10Z" }), jsx("path", { fill: "#2D2E2E", d: "M15.25 11a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5Z" })] }));

export { SvgActionPhoto as default };
//# sourceMappingURL=ActionPhoto.es.js.map
